var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2281_11032)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M22.4934 2.05682C23.5483 2.06087 24.5236 2.61876 25.0619 3.52608L31.5959 14.5395C32.1536 15.4795 32.1559 16.6485 31.602 17.5907L25.1796 28.5139C24.6386 29.4341 23.6494 29.9975 22.582 29.9934L9.50665 29.9432C8.45167 29.9391 7.47636 29.3812 6.93806 28.4739L0.404058 17.4605C-0.153644 16.5205 -0.155949 15.3515 0.39804 14.4093L6.82039 3.48607C7.3614 2.56591 8.3506 2.00252 9.41802 2.00662L22.4934 2.05682Z",
    fill: "#E05281"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2929 10.2929C10.6834 9.90237 11.3166 9.90237 11.7071 10.2929L16 14.5858L20.2929 10.2929C20.6834 9.90237 21.3166 9.90237 21.7071 10.2929C22.0976 10.6834 22.0976 11.3166 21.7071 11.7071L17.4142 16L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16 17.4142L11.7071 21.7071C11.3166 22.0976 10.6834 22.0976 10.2929 21.7071C9.90237 21.3166 9.90237 20.6834 10.2929 20.2929L14.5858 16L10.2929 11.7071C9.90237 11.3166 9.90237 10.6834 10.2929 10.2929Z",
    fill: "#E05281"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2281_11032"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.e6192e0349c76a033d7e8b56f9594dc8.svg";
export { ForwardRef as ReactComponent };